/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_Manager_DescInputs */



/**
* | output |
* | --- |
* | "Manages projects, KNP lists and assignments" |
*
* @param {Team_Manager_Role_Manager_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_manager_desc = /** @type {((inputs?: Team_Manager_Role_Manager_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_Manager_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gère les projets, listes KNP et attributions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwaltet Projekte, KNP-Listen und Zuweisungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisce progetti, elenchi KNP e assegnazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управляет проектами, списками KNP и назначениями")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestiona proyectos, listas KNP y asignaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理项目、KNP 列表和分配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト・KNP リスト・割り当てを管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट, KNP सूचियाँ और असाइनमेंट प्रबंधित करता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gere projetos, listas KNP e atribuições")
	return /** @type {LocalizedString} */ ("Manages projects, KNP lists and assignments")
});